import { render, staticRenderFns } from "./MasrafCesitleriForm.vue?vue&type=template&id=93235a0a"
import script from "./MasrafCesitleriForm.vue?vue&type=script&lang=ts"
export * from "./MasrafCesitleriForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports